/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route, Routes, Navigate } from 'react-router-dom'
import { ForgotPassword } from './components/ForgotPassword'
import { Login } from './components/Login'
import { ResetPassword } from './components/ResetPassword'
import { Otp } from './components/Otp'
import { SignUp } from './components/SignUp'
import { PaymentFailed } from './components/PaymentFailed'
import { AcceptInvite } from './components/AcceptInvite'

const AuthPage = () => (
  <Routes>
    <Route>
      <Route path='login' element={<Login />} />
      <Route path='otp' element={<Otp />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='set-password/:tokenDetail' element={<ResetPassword />} />
      <Route path='accept-invite' element={<AcceptInvite />} />
      <Route path='sign-up' element={<SignUp />} />
      <Route path='payment-failed' element={<PaymentFailed />} />
      <Route index element={<Login />} />
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Route>
  </Routes>
)

export { AuthPage }
